import { Link } from '@chakra-ui/react';
import { memo } from 'react';

import BlurredCell from './BlurredCell';

export interface ProfileUrlCellProps {
  value: string;
  isRestricted?: boolean;
  encryptedValue?: string;
  userKey?: string;
  fieldKey?: string;
  onMouseEnter?: () => void;
  allowUnblur?: boolean;
  'data-testid'?: string;
}

const noop = () => undefined;

export const ProfileUrlCell = memo(function ProfileUrlCell({
  value,
  isRestricted,
  encryptedValue,
  userKey,
  fieldKey,
  onMouseEnter,
  allowUnblur,
  'data-testid': testId,
}: ProfileUrlCellProps) {
  const urlValue = String(value ?? '');
  const url = urlValue.toLowerCase().trim() === 'empty' ? '' : urlValue;

  if (url.length === 0) {
    return (
      <div data-testid={testId}>
        {urlValue.toLowerCase().trim() === 'empty' ? '' : urlValue}
      </div>
    );
  }

  if (isRestricted) {
    return (
      <BlurredCell
        value={urlValue}
        encryptedValue={encryptedValue}
        userKey={userKey}
        fieldKey={fieldKey}
        onMouseEnter={onMouseEnter ?? noop}
        allowUnblur={allowUnblur}
        data-testid={testId}
      />
    );
  }

  return (
    <Link
      href={
        urlValue.startsWith('http://') || urlValue.startsWith('https://')
          ? urlValue
          : `https://${urlValue}`
      }
      isExternal
      rel="noopener noreferrer"
      data-testid={testId}
      color="lightBlue.600"
    >
      {urlValue.toLowerCase().trim() === 'empty' ? '' : urlValue}
    </Link>
  );
});

export default ProfileUrlCell;
